export const viewTitle = "Книга учета поступлений документов";
export const viewUniqKey = "receiptDocumentsBookReport";
